module.exports = __webpack_public_path__ + "static/img/Baguette.fbb4706.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Baguette.jpg
// module id = xId+
// module chunks = 1